import BackButton from '@/components/back-button';
import { DS_HEIGHT, DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import {
    FullPageFullWidthContainer,
    FullPagePaddedContainer,
    fullPagePaddingPx,
} from '@rhg/components/full-page-container';
import { Heading, Placeholder } from '@rhg/components/heading';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import discoverMessages from '@rhg/lang/messages/discover';
import { Box, Theme } from '@rhg/libs/material';
import { routes } from '@rhg/utils/routes';
import React, { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

const styleBackground = {
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
    minHeight: `calc(100dvh - ${DS_HEIGHT.TOOLBAR}px)`,
    pb: 10,
};

const styleDiscoverDailiesHeader = {
    pt: 10,
};

export const discoverPaddingPx = fullPagePaddingPx;
export const DiscoverPaddedContainer = FullPagePaddedContainer;
export const DiscoverFullWidthContainer = FullPageFullWidthContainer;

const styleBackButtonOverrides = {
    position: {
        xs: 'relative',
    },
    left: 0,
    top: 0,
};

export const DiscoverDailiesLayout = ({ children }: PropsWithChildren) => {
    const { formatMessage } = useIntl();
    const title = formatMessage(discoverMessages['discover.daily_practice']);
    const subtitle = formatMessage(
        discoverMessages['discover.daily_practice_subtitle']
    );
    const isMobile = useIsMobile('md');
    return (
        <Box sx={styleBackground}>
            <DiscoverPaddedContainer sx={styleDiscoverDailiesHeader}>
                <Heading
                    leftButton={
                        <BackButton
                            fallbackRoute={routes.discover}
                            sx={styleBackButtonOverrides}
                        />
                    }
                    titleVariant={isMobile ? 'h5' : 'h4'}
                    rightButton={<Placeholder />}
                    title={title}
                    titleAlign="center"
                    subtitle={subtitle}
                    subtitleAlign="center"
                    subtitleWillRenderLinks
                    subTitleColumns={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 8 }}
                    spacing={DS_SPACING_UNITS.HEADING_DESCRIPTION}
                    sx={{
                        mb: DS_SPACING_UNITS.SECTION,
                    }}
                />
            </DiscoverPaddedContainer>
            {children}
        </Box>
    );
};
